import React, { useState } from 'react';
import { Card } from '../../components/ui/Card';
const availableClasses = [{
  name: 'A Letter From ADRE',
  creditType: '3 hrs. Comm. Standards',
  note: null
}, {
  name: 'Accidental Property Management',
  creditType: '3 hrs. Legal Issues',
  note: null
}, {
  name: 'Are They Represented?',
  creditType: '3 hrs. Agency Law',
  note: null
}, {
  name: 'Avoid The Oops: Contract Smarts for Agents',
  creditType: '3 hrs. Contract Law',
  note: null
}, {
  name: 'BMC #1 AZ Residential-Statutes and Rules',
  creditType: '3 hrs. Comm. Standards',
  note: null
}, {
  name: 'BMC #2 AZ Residential-Broker Policies',
  creditType: '3 hrs. Comm. Standards',
  note: null
}, {
  name: 'BMC #3 AZ Residential-Broker Supervision',
  creditType: '3 hrs. Comm. Standards',
  note: null
}, {
  name: 'BMC #3B Property Management',
  creditType: '3 hrs. Comm. Standards',
  note: null
}, {
  name: 'Deeds, Fires & Water: Be Prepared',
  creditType: '3 hrs. General',
  note: null
}, {
  name: "Don't Lose Your License",
  creditType: '3 hrs. Comm. Standards',
  note: null
}, {
  name: 'Ethics & The Rules (with NAR Code of Ethics)',
  creditType: '3 hrs. Comm. Standards',
  note: null
}, {
  name: "Fair Housing In Today's World",
  creditType: '3 hrs. Fair Housing',
  note: null
}, {
  name: 'Follow All The Laws',
  creditType: '3 hrs. Legal Issues',
  note: null
}, {
  name: 'Mastering Agency Agreements',
  creditType: '3 hrs. Agency Law',
  note: null
}, {
  name: 'NAR Code of Ethics (NO CE CREDIT)',
  creditType: 'NONE',
  note: 'This course is not available with this package.'
}, {
  name: 'No Secrets',
  creditType: '3 hrs. Disclosure',
  note: null
}, {
  name: 'The Bottom Line of Disclosure',
  creditType: '3 hrs. Disclosure',
  note: null
}, {
  name: 'The Owner Is In Default',
  creditType: '3 hrs. Legal Issues',
  note: null
}, {
  name: 'They Are A Protected Class',
  creditType: '3 hrs. Fair Housing',
  note: null
}, {
  name: 'What Goes Wrong In Contracts',
  creditType: '3 hrs. Contract Law',
  note: null
}, {
  name: 'Your Clients Are Not Mushrooms',
  creditType: '3 hrs. Disclosure',
  note: null
}];
export function AvailableClasses() {
  const [selected, setSelected] = useState<Set<number>>(new Set());
  const toggle = (i: number) => {
    setSelected(prev => {
      const next = new Set(prev);
      next.has(i) ? next.delete(i) : next.add(i);
      return next;
    });
  };
  return <div className="space-y-4" data-id="element-1651" data-mp="2031rfyn5wmi9">
      <div className="rounded-xl px-6 py-5 text-white" style={{
      backgroundColor: '#4A2D8F'
    }} data-id="element-1652" data-mp="254iplme9huv5">
        <h1 className="text-2xl font-extrabold tracking-tight mb-1" data-id="element-1653" data-mp="5sfzvuf1o491">
          Available Classes
        </h1>
        <p className="text-purple-200 text-sm" data-id="element-1654" data-mp="aq80dctr8you">
          Select classes to add to your enrollment (My Classes).
        </p>
      </div>

      {/* Info block */}
      <div className="text-sm text-slate-700 space-y-3" data-id="element-1655" data-mp="2j99clvr9s8fe">
        <p data-id="element-1656" data-mp="2j7oi264ygphj">
          You have 0 available classes to choose from.{' '}
          <button className="text-blue-600 hover:underline font-medium" data-id="element-1657" data-mp="2f85v74tkq4c2">
            Click here to purchase classes &gt;&gt;
          </button>
        </p>

        <p data-id="element-1658" data-mp="36zln9edwgj9o">
          <strong data-id="element-1659" data-mp="36y28js7w6ga0">Salesperson</strong>
        </p>
        <p data-id="element-1660" data-mp="36wr7i05tzmml">
          Your 24 hour requirement (every two years), includes 21 hours (7 class
          types), with at least one class (3 hrs) of each of the following
          credit types:
        </p>

        <ul className="space-y-0.5 pl-1" data-id="element-1661" data-mp="2y08cmie1hond">
          <li data-id="element-1662" data-mp="2sy9blf5rv3tl">• Agency Law</li>
          <li data-id="element-1663" data-mp="2sz2m8r7uqdh0">• Contract Law</li>
          <li data-id="element-1664" data-mp="1mj8l3ozindue">• Disclosure</li>
          <li data-id="element-1665" data-mp="1mka024jnkkhe">• Fair Housing</li>
          <li data-id="element-1666" data-mp="1mkjty37tjbsd">• General Deed Fraud, Firewise &amp; AZ Water</li>
          <li data-id="element-1667" data-mp="1hj4663e9ar6a">• Legal Issues</li>
          <li data-id="element-1668" data-mp="1hiug6ft7ok0l">
            • Requirements for Licensees (formerly Commissioner's
            Standards/Rules)
          </li>
          <li data-id="element-1669" data-mp="3a7jze0k47qe1">
            • <strong data-id="element-1670" data-mp="3a7bp8gfdmz6j">Elective:</strong> 1 class (3 hours) &mdash; you may
            choose any credit type, providing you do not duplicate any course
            you have already taken within that renewal period
          </li>
        </ul>

        <p data-id="element-1671" data-mp="31g1i1mbfn4jd">
          <strong data-id="element-1672" data-mp="31fi2udd62u91">
            Designated, Self-employed Brokers and Associate Brokers with
            Supervisory responsibility are required to take 30 CE credits (every
            2 years) for license renewal (including the credit types noted for
            Salespersons + Broker Management 1-3)
          </strong>
        </p>

        {/* ADRE timed-class note callout */}
        <div className="rounded-lg border-l-4 p-4" style={{
        backgroundColor: '#FFF8E1',
        borderLeftColor: '#E8A020'
      }} data-id="element-1673" data-mp="3k4ga8cxhkolr">
          <p className="text-sm font-bold text-slate-800 mb-1" data-id="element-1674" data-mp="28qukapjsyiz6">
            NOTE: ADRE Timed Class Requirement
          </p>
          <p className="text-xs text-slate-700 leading-relaxed" data-id="element-1675" data-mp="215if1vngpwxh">
            ADRE requires that ALL 3 hr. CE classes, either Live, Distance
            Learning and Zoom, run for a total of 150 minutes. As required by
            ADRE, all sections in a Distance Learning class is timed. When you
            begin a section, the timer will begin at 25 minutes. As long as your
            class is open and your browser is connected to the server, the timer
            will continue to count down. If you leave the class, your device
            goes to sleep, click on an outside link, or shut off your computer,
            the timer will stop and will begin again where you left off when you
            log back into the class.
          </p>
        </div>
      </div>

      {/* Table */}
      <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-1676" data-mp="yr9yl0xwkfvm">
        <div className="overflow-x-auto" data-id="element-1677" data-mp="tu9uuwoizp7o">
          <table className="w-full text-sm text-left" data-id="element-1678" data-mp="tt883uy5dea4">
            <thead style={{
            backgroundColor: '#4A2D8F'
          }} className="text-white font-medium" data-id="element-1679" data-mp="2twj6spv0u1t9">
              <tr data-id="element-1680" data-mp="33lkkg9e3g742">
                <th className="px-3 py-2 border-r border-purple-700 w-8" data-id="element-1681" data-mp="33l11qqgmdeoz"></th>
                <th className="px-3 py-2 border-r border-purple-700" data-id="element-1682" data-mp="38knr1y9q2le5">Class</th>
                <th className="px-3 py-2 border-r border-purple-700 w-48" data-id="element-1683" data-mp="38mqeqbnek2fp">
                  Credit Type
                </th>
                <th className="px-3 py-2 w-20 text-center" data-id="element-1684" data-mp="2fvyodut0q80a">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200" data-id="element-1685" data-mp="2kvb661518ow0">
              {availableClasses.map((cls, i) => <tr key={i} className="hover:bg-purple-50/20" data-id="element-1686" data-mp="2ox69tcafrecy" data-mpi={i}>
                  <td className="px-3 py-1.5 border-r border-slate-200 text-center" data-id="element-1687" data-mp="2oubo7hfornhy">
                    <input type="checkbox" checked={selected.has(i)} onChange={() => toggle(i)} className="rounded border-slate-300" disabled={!!cls.note} data-id="element-1688" data-mp="4kf3gbkuak0" />
                  </td>
                  <td className="px-3 py-1.5 border-r border-slate-200" data-id="element-1689" data-mp="1kozcajooqfzp">
                    <div className="text-slate-800 leading-snug" data-id="element-1690" data-mp="1fulgwha0w8v1">
                      {cls.name}
                    </div>
                    {cls.note && <div className="text-xs text-slate-500 italic leading-snug" data-id="element-1691" data-mp="15yi48hhjortu">
                        {cls.note}
                      </div>}
                  </td>
                  <td className="px-3 py-1.5 border-r border-slate-200 text-slate-700 whitespace-nowrap" data-id="element-1692" data-mp="wx0ncwwbcm43">
                    {cls.creditType}
                  </td>
                  <td className="px-3 py-1.5 text-center text-slate-700" data-id="element-1693" data-mp="s0abymvgeep0"></td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>

      <div data-id="element-1694" data-mp="2mcrrf8a1waj3">
        <button className="px-4 py-1.5 text-sm border border-slate-400 bg-slate-100 hover:bg-slate-200 rounded text-slate-800 transition-colors" data-id="element-1695" data-mp="2md02qvqiz7s6">
          Enroll Me
        </button>
      </div>
    </div>;
}